import { GET_QUIZ } from '../constants';
import { getContent } from '../../services/api';

const fetchQuiz = (slug, locale) => ({
  type: GET_QUIZ,
  payload: getContent({ contentType: 'eLearningQuiz', slug, locale }),
});

export default fetchQuiz;
